import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { A } from '@adornis/base/env-info.js';

/** OTRS queue names that may trigger partner scheduling. */
@Entity()
export class PartnerSchedulingAllowedQueue extends MongoEntity {
  static override _class = 'PartnerSchedulingAllowedQueue';
  static override _collectionName = 'partner-scheduling-allowed-queues';

  static override resolveID(entity: PartnerSchedulingAllowedQueue): string {
    return (entity._id ??= entity.queueName?.trim() ?? A.getGloballyUniqueID());
  }

  @Field(() => String, { default: v => v ?? A.getGloballyUniqueID() })
  override _id!: string;

  /** Exact OTRS queue name (trimmed); matched against ticket `Queue`. */
  @Field(() => String)
  queueName: Maybe<string>;
}
